import React from "react";

export default function ImageRichtext({ content }) {
  return (
    <div className="imageRichtext" id="imageRichtext">
      <div className="content">
        <div className="contentLeft">
          <img src={content?.image?.url} alt="" />
        </div>
        <div className="contentRight">
          <div className="richText" dangerouslySetInnerHTML={{ __html: content?.richtext }} />
        </div>
      </div>
    </div>
  );
}
